import { render, staticRenderFns } from "./PFAC.vue?vue&type=template&id=08b24710"
import script from "./PFAC.vue?vue&type=script&lang=js"
export * from "./PFAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports